export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 1c1.263 0 2.389.586 3.122 1.5H19.5a1 1 0 011 1v17a1 1 0 01-1 1h-15a1 1 0 01-1-1v-17a1 1 0 011-1h3.378A3.993 3.993 0 0111.001 1h2zM5.5 4.5v15h13v-15h-1.533c.02.164.034.33.034.5v1a1 1 0 01-1 1H8a1 1 0 01-1-1V5c0-.17.011-.336.032-.5H5.5zM11 3a2 2 0 00-2 2h6a2 2 0 00-2-2h-2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};